import { Chip, styled } from '@mui/material';

interface StyledChipProps {
  $overflow?: boolean;
  $tooltipActivationWidth?: number;
  $isNotMatched?: boolean;
}

export const StyledChip = styled(Chip)<StyledChipProps>`
  .MuiChip-label {
    display: inline-block;
    overflow: ${({ $overflow }: StyledChipProps) =>
      $overflow ? 'hidden' : 'visible'};
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: ${({ $tooltipActivationWidth }: StyledChipProps) =>
      $tooltipActivationWidth ? `${$tooltipActivationWidth}px` : 'fit-content'};
  }
  ${({ $isNotMatched }: StyledChipProps) =>
    $isNotMatched &&
    `
    & .MuiChip-label,
    & .MuiChip-icon {
      color: #99001C;
    }
  `}
`;
